import { YStack, XStack, Text, View } from "tamagui";
import { colors } from "@styles/colors";
import { useHazePage, v2 } from "@screen/Home/pages/GasShop/skin";
import { Fade, RADIUS, StickyBtn } from "./Common";
import { Ic, Ar } from "./Icons";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { RiCheckboxCircleLine } from "react-icons/ri";

export default function JoinSuccess({ info, onDone }: any) {
  // 淡霧頁：這一組白字與白色圖示原本坐在藍色漸層上，換皮後在淡藍白底上完全讀不到
  const haze = useHazePage();
  // status: "active" → 已立即加入；"invited" → 待負責人核准。其餘（如序號配對）視為已加入。
  const pending = info?.status === "invited";
  const heroTitle = pending ? "已送出加入申請" : "歡迎加入";
  const heroSub = pending ? "待負責人核准後即可共同管理" : "您已成功連結帳戶";
  return (
    <RadiusContentWrapper padding="0" space={0} background="transparent" contentContainerStyle={{ paddingBottom: 24 }}>
      <YStack>
        {/* 成功畫面的慶祝段直接坐在整頁漸層上。
            原本是一塊自帶漸層、下緣圓角 35 的藍色卡——疊在 V2 的頁面漸層上會變成兩層藍，
            交界處看得到一道邊，右上角那顆裝飾大圓也只在那塊卡裡被裁掉一半。 */}
        <YStack px="$5" pt={30} pb="$5" ai="center">
          <RiCheckboxCircleLine color={haze ? colors.green : "#ffffffd8"} size={50} />
          <Text fontSize={22} fontWeight="800" color={haze ? v2.hazeInk : "#fff"} mb="$1" mt="$2">
            {heroTitle}
          </Text>
          <Text fontSize={14} color={haze ? v2.hazeSub : "rgba(255,255,255,0.88)"}>
            {heroSub}
          </Text>
        </YStack>

        <YStack p="$5" gap="$4">
          <Fade i={0}>
            <XStack bg={colors.light} br={RADIUS} p="$4" ai="center" gap="$3.5">
              <View w={48} h={48} br={12} bg={`${colors.primary}20`} ai="center" jc="center" flexShrink={0}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 11l9-8 9 8v10a2 2 0 01-2 2h-4v-7h-6v7H5a2 2 0 01-2-2V11z"
                    stroke={colors.primary}
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </View>
              <YStack f={1}>
                <XStack ai="center" gap="$1.5" mb={1}>
                  <Text fontSize={15} fontWeight="800">
                    {info.label || info.name}
                  </Text>
                  <View bg={colors.primary} px="$2" py="$0.5" br={7}>
                    <Text fontSize={9} fontWeight="700" color="#fff">
                      群組共享
                    </Text>
                  </View>
                </XStack>
                <Text fontSize={11} color={colors.gray200}>
                  {info.vendor || "瓦斯行"} · 你是「{info.role || "成員"}」
                </Text>
              </YStack>
            </XStack>
          </Fade>

          <Fade i={1}>
            <YStack gap="$2">
              <Text fontSize={12} fontWeight="600" color={colors.gray} pl={2}>
                接下來您可以…
              </Text>
              <YStack bg={colors.light} br={RADIUS} ov="hidden">
                {[
                  {
                    d: "M3 11l9-8 9 8v10a2 2 0 01-2 2h-4v-7h-6v7H5a2 2 0 01-2-2V11z",
                    c: info.color || colors.primary,
                    l: "查看帳戶資訊",
                    s: "看訂單、地址、瓦斯量",
                  },
                  { d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6", c: colors.primary, l: "查看訂單紀錄", s: "看歷史下單紀錄" },
                  {
                    d: "M3 10h18M5 6h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z",
                    c: colors.purple,
                    l: "管理付款方式",
                    s: "加自己的卡或申請授權",
                  },
                ].map((item, i, a) => (
                  <XStack
                    key={i}
                    p="$3.5"
                    borderBottomWidth={i < a.length - 1 ? 1 : 0}
                    borderBottomColor={colors.bgGray1}
                    ai="center"
                    gap="$3"
                    cursor="pointer"
                    pressStyle={{ bg: colors.bg }}>
                    <View w={32} h={32} br={8} bg={`${item.c}18`} ai="center" jc="center" flexShrink={0}>
                      <Ic d={item.d} c={item.c} s={15} sw={1.8} />
                    </View>
                    <YStack f={1}>
                      <Text fontSize={14} fontWeight="600">
                        {item.l}
                      </Text>
                      <Text fontSize={11} color={colors.gray200} mt={1}>
                        {item.s}
                      </Text>
                    </YStack>
                    <Ar />
                  </XStack>
                ))}
              </YStack>
            </YStack>
          </Fade>

          <Fade i={2}>
            <XStack bg={colors.primaryActive} br={RADIUS} p="$3.5" gap="$2.5">
              <Ic d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" c={colors.primary} s={15} />
              <YStack f={1}>
                <Text fontSize={11} color={colors.primary} fontWeight="700" mb={1}>
                  帳戶通知
                </Text>
                <Text fontSize={11} color={colors.primary} lineHeight={16}>
                  負責人將會收到您加入帳戶的推播通知。
                </Text>
              </YStack>
            </XStack>
          </Fade>
        </YStack>

        {/* 改用共用的 StickyBtn（與 JoinCode／JoinSerial／StepSelect 同一顆）。
            原本這裡是手寫的：不透明底色帶 + 漸層 + 圓角 20——
            不透明帶會在捲動內容上切出一條硬邊，漸層又讓它變成版面裡的第二個重心；
            StickyBtn 用的是「由透明淡入頁面底色」的襯底 + 實色膠囊。 */}
        <YStack px="$4">
          <StickyBtn label="完成 · 回到首頁" onClick={onDone} />
        </YStack>
      </YStack>
      <style>{`@keyframes popIn { 0% { transform:scale(0); opacity:0; } 60% { transform:scale(1.08); } 100% { transform:scale(1); opacity:1; } }`}</style>
    </RadiusContentWrapper>
  );
}
